import ConfigDB from '../../../Config/ThemeConfig';
const month = ['Jan', 'Feb', 'March', 'April', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];
const d = new Date();
export const ClockData = {
  dateShow: month[d.getMonth()] + ' ' + d.getDate() + ', ' + d.getFullYear(),
  options: {
    width: '180px',
    border: true,
    borderColor: '#2e2e2e',
    centerColor: '#459cff',
    centerBorderColor: '#ffffff',
    handColors: {
      second: ConfigDB.color.primary_color || localStorage.getItem('default_color'),
      minute: ConfigDB.color.secondary_color || localStorage.getItem('secondary_color'),
      hour: '#ffffff',
    },
  },
};
